export const elevations = {
  'elevation-1':
    '2px 4px 4px 0px rgba(61, 67, 76, 0.40), 2px 4px 8px 2px rgba(61, 67, 76, 0.10)',
  'elevation-2':
    '0px 6px 14px -6px rgba(222, 232, 243, 0.65), 0px 10px 32px -4px rgba(222, 232, 243, 0.65)',
  'elevation-3':
    '0px 14px 64px -4px rgba(222, 232, 243, 0.65), 0px 8px 22px -6px rgba(222, 232, 243, 0.65)',
};
